var React = require('react');

function PatternInline (props) {
    return React.createElement("svg",props,React.createElement("use",{"className":"pattern","xlinkHref":"#centre-pattern-root","x":"70","y":"0","height":"144"}));
}

PatternInline.defaultProps = {"viewBox":"0 0 800 180","preserveAspectRatio":"xMidYMin slice"};

module.exports = PatternInline;

PatternInline.default = PatternInline;
